import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { onAuthChange } from "../services/auth.service";
import { getCategories } from "../services/category.service";

const HeaderThree = () => {
  const { cartCount } = useCart();
  const { wishlist } = useWishlist();
  const wishlistCount = wishlist.length;
  const [user, setUser] = useState(null);
  const [categories, setCategories] = useState([]);
  const [, setSelectedCategory] = useState("all");

  useEffect(() => {
    const fetchCategories = async () => {
      const data = await getCategories();
      setCategories(data);
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthChange((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();
    selectElement.on('change', (e) => {
      setSelectedCategory(e.target.value);
    });

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);

  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };


  return (
    <>
      {/*==================== Overlay Start ====================*/}
      <div className='overlay' />
      {/*==================== Overlay End ====================*/}
      {/*==================== Sidebar Overlay End ====================*/}
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/*==================== Sidebar Overlay End ====================*/}


      {/* ==================== Mobile Menu Start Here  ==================== done */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
          }}
          type='button'
          className='close-button'
        >
          <i className='ph ph-x' />{" "}
        </button>
        <div className='mobile-menu__inner'>
          <div className='logo px-16 d-lg-none d-block'>
            <Link to='/' className='link'>
              <img src='/assets/images/logo/logo.png' alt='Logo' />
            </Link>
          </div>
          <div className='mobile-menu__menu'>
            {/* Nav Menu Start */}
            <ul className='nav-menu flex-align nav-menu--mobile'>
              <li className='nav-menu__item'>
                <NavLink to='/' className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>
                  Home
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/shop' className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>
                  Shop
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/workshops' className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>
                  Workshops
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/about' className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>
                  About Us
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/contact' className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>
                  Contact Us
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/account' className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-8" : "nav-menu__link flex-align gap-8"}>
                  <i className='ph ph-user text-xl' />
                  {user ? (user.displayName || "Profile") : "Login / Register"}
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/wishlist' className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-8 justify-content-between w-100" : "nav-menu__link flex-align gap-8 justify-content-between w-100"}>
                  <span className="flex-align gap-8">
                    <i className='ph ph-heart text-xl' />
                    Wishlist
                  </span>
                  {wishlistCount > 0 && (
                    <span className='d-inline-flex align-items-center justify-content-center bg-main-two-600 text-white rounded-circle' style={{ width: '20px', height: '20px', fontSize: '11px', fontWeight: 'bold' }}>
                      {wishlistCount}
                    </span>
                  )}
                </NavLink>
              </li>
              <li className='nav-menu__item'>
                <NavLink to='/cart' className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-8 justify-content-between w-100" : "nav-menu__link flex-align gap-8 justify-content-between w-100"}>
                  <span className="flex-align gap-8">
                    <i className='ph ph-shopping-cart-simple text-xl' />
                    Cart
                  </span>
                  {cartCount > 0 && (
                    <span className='d-inline-flex align-items-center justify-content-center bg-main-two-600 text-white rounded-circle' style={{ width: '20px', height: '20px', fontSize: '11px', fontWeight: 'bold' }}>
                      {cartCount}
                    </span>
                  )}
                </NavLink>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}

      {/* ==================== Header Two Start Here ==================== */}
      <header
        className={`header bg-color-neutral border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className='container container-lg'>
          <nav className='header-inner d-flex justify-content-between gap-8'>
            <div className='flex-align menu-category-wrapper'>
              {/* Logo Start */}
              <div className='logo me-4 me-sm-24 bg-white rounded-8 flex-shrink-0 logo-wrapper-responsive' style={{ display: 'flex', alignItems: 'center' }}>
                <Link to='/' className='link d-flex align-items-center'>
                   <img
                    src='/assets/images/logo/logo.png'
                    className='logo-img-responsive'
                    alt='Logo'
                  />
                </Link>
              </div>
              {/* Logo End  */}
              {/* Category Dropdown Start */}
              <div className='category-two d-lg-none d-block'>
                <button
                  onClick={handleCategoryToggle}
                  type='button'
                  className='category__button flex-align gap-4 fw-medium bg-main-600 py-8 px-12 text-white text-nowrap flex-shrink-0 rounded-4 text-xs text-sm-sm'
                >
                  <span className='icon text-lg d-flex'>
                    <i className='ph ph-dots-nine' />
                  </span>
                  <span>Categories</span>
                  <span className='arrow-icon text-sm d-flex'>
                    <i className='ph ph-caret-down' />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat common-dropdown d-lg-none d-block nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                    }}
                    type='button'
                    className='close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex'
                  >
                    <i className='ph ph-x' />{" "}
                  </button>
                  <div className='logo px-16 d-lg-none d-block'>
                    <Link to='/' className='link'>
                      <img src='/assets/images/logo/logo.png' alt='Logo' />
                    </Link>
                  </div>
                  <ul className='submenus-list'>
                    {categories.map((cat, index) => (
                      <li
                        key={cat.id}
                        className='has-submenus-submenu'
                      >
                        <Link
                          to={`/shop?category=${encodeURIComponent(cat.name)}`}
                          className='text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0'
                        >
                          <span>{cat.name}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className='d-none d-lg-block'>
                <div className='category on-hover-item bg-main-600 text-white'>
                  <button
                    type='button'
                    className='category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-white text-nowrap flex-shrink-0'
                  >
                    <span className='icon text-2xl d-xs-flex d-none'>
                      <i className='ph ph-dots-nine' />
                    </span>
                    <span className='d-sm-flex d-none'>All</span> Categories
                    <span className='arrow-icon text-xl d-flex'>
                      <i className='ph ph-caret-down' />
                    </span>
                  </button>
                  <div className='responsive-dropdown on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper'>
                    <button
                      type='button'
                      className='close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex'
                    >
                      <i className='ph ph-x' />{" "}
                    </button>
                    <div className='logo px-16 d-lg-none d-block'>
                      <Link to='/' className='link'>
                        <img src='/assets/images/logo/logo.png' alt='Logo' />
                      </Link>
                    </div>
                    <ul className='scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto'>
                      {categories.map((cat) => (
                        <li key={cat.id} className='has-submenus-submenu'>
                          <Link
                            to={`/shop?category=${encodeURIComponent(cat.name)}`}
                            className='text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0'
                          >
                            <span>{cat.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className='header-menu d-lg-block d-none'>
                {/* Nav Menu Start */}
                <ul className='nav-menu flex-align '>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage text-white"
                          : "nav-menu__link text-white"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/shop'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage text-white"
                          : "nav-menu__link text-white"
                      }
                    >
                      Shop
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/workshops'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage text-white"
                          : "nav-menu__link text-white"
                      }
                    >
                      Workshops
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/about'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage text-white"
                          : "nav-menu__link text-white"
                      }
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/contact'
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage text-white"
                          : "nav-menu__link text-white"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className='header-right flex-align flex-shrink-0'>
              <div className='flex-align gap-32 d-none d-lg-flex'>
                <NavLink
                  to='/account'
                  className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-6 text-nowrap text-white" : "nav-menu__link flex-align gap-6 text-nowrap text-white"}
                >
                  <i className='ph ph-user flex-shrink-0' />
                  {user ? (user.displayName || "Profile") : "Login"}
                </NavLink>
                <NavLink
                  to='/wishlist'
                  className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-6 text-nowrap text-white" : "nav-menu__link flex-align gap-6 text-nowrap text-white"}
                >
                  <span className="position-relative d-inline-flex flex-shrink-0">
                    <i className='ph ph-heart' />
                    {wishlistCount > 0 && (
                      <span className='w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-0 start-100 translate-middle'>
                        {wishlistCount}
                      </span>
                    )}
                  </span>
                  Wishlist
                </NavLink>
                <NavLink
                  to='/cart'
                  className={(navData) => navData.isActive ? "nav-menu__link activePage flex-align gap-6 text-nowrap text-white" : "nav-menu__link flex-align gap-6 text-nowrap text-white"}
                >
                  <span className="position-relative d-inline-flex flex-shrink-0">
                    <i className='ph ph-shopping-cart-simple' />
                    {cartCount > 0 && (
                      <span className='w-16 h-16 flex-center rounded-circle bg-main-two-600 text-white text-xs position-absolute top-0 start-100 translate-middle'>
                        {cartCount}
                      </span>
                    )}
                  </span>
                  Cart
                </NavLink>
              </div>

              <button
                onClick={handleMenuToggle}
                type='button'
                className='toggle-mobileMenu d-lg-none ms-2 text-white text-4xl d-flex flex-shrink-0'
              >
                {" "}
                <i className='ph ph-list' />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderThree;